// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2Ojgm","buttons":"Footer_buttons__3qw0c"};